export const HARDCODED_PROJECT_ID = 11;

export const SEGMENT_CARD_COLORS = ['#28aae1', '#565add', '#1D94C7', '#7b7bc7', '#76d1ff', '#b3b5e8', '#4CB847'];
